import { Link } from "react-router-dom";
import { ArrowLeft, Sparkles } from "lucide-react";
import AiAgent from "@/pages/AiAgent";

export default function AiAgentStandalone() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-20 bg-white/90 backdrop-blur border-b border-slate-200">
        <div className="max-w-3xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="w-8 h-8 rounded-xl bg-[#E05638] text-white grid place-items-center"><Sparkles size={16} /></span>
            <span className="font-heading font-extrabold text-slate-900">Mon Agent IA</span>
          </div>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 hover:text-slate-900" data-testid="ia-standalone-home">
            <ArrowLeft size={15} /> Retour au site
          </Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-6">
        <AiAgent hideHeader />
      </main>
    </div>
  );
}
